<template>
<div class="goodsList_ui">
    <div class="waterfall" v-if="closeWaterfall!='T'">
        <waterfall :col="col" :data="goodsListData" :width="itemWidth"  v-if="goodsListData.length>0">
            <template>
                <van-cell v-for="(item,i) in goodsListData" :key="i" class="goods-box">
                    <div class="goods-box-box" v-if="goodsListData.length>0&&(i<number||number==-1)" @click="goGoodsDetail(item,i)">
                        <div class="img-box">
                            <div class="img-box-content" :class="{'img-box-square':isSquarePic=='T'}">
                                <div class="label" v-if="item.goodsCity&&item.goodsCity!=''">
                                    {{item.goodsCity|keyFilter}}
                                </div>

                                <img class="img" :src="item.logo+'?imageMogr2/thumbnail/334x'" />
                                <div class="hotelName" v-if="item.supplierName&&item.supplierName!=''&&showListHotelName!='F'&&hideHotelInfo!='T'">
                                    <b>{{item.supplierName}}</b>
                                </div>
                                <div class="hotelName" v-else-if="item.hotelName&&item.hotelName!=''&&showListHotelName!='F'&&hideHotelInfo!='T'">
                                    <b>{{item.hotelName}}</b>
                                </div>
                            </div>

                        </div>
                        <div class="goods-content-common">
                            <div class="goods-name">{{item.name}}</div>
                            <div class="goods-discount" v-if="item.extraInfo&&item.extraInfo.discountList">
                                <div class="goods-discount-item" v-if="item.extraInfo.discountList.length>0" v-for="(discount,j) in item.extraInfo.discountList" :key="j">
                                    {{discount.discountTxt}}
                                </div>
                            </div>
                            <div class="goods-price-credit" v-if="item.price>0&&item.credit>0">
                                <div class="price-box">
                                    <i class="rmb">¥</i>
                                    <div class="price">
                                        {{item.price}}
                                    </div>
                                    <div class="qi" v-if="item.skuFlag">起</div>
                                    <div class="proposedPrice" v-if="item.proposedPrice>0">
                                        ¥{{item.proposedPrice}}
                                    </div>
                                </div>
                                <div class="credit-box">
                                    <span v-if="priceOrCredit!='T'">+</span>{{item.credit}}{{creditName}}<span v-if="priceOrCredit=='T'">兑换</span>
                                </div>
                            </div>
                            <div class="goods-price" v-else-if="item.price>0||(item.skuFlag&&item.price<=0&&item.credit<=0)">
                                <div class="price-box">
                                    <i class="rmb">¥</i>
                                    <div class="price">
                                        {{item.price}}
                                    </div>
                                    <div class="qi" v-if="item.skuFlag">起</div>
                                </div>

                                <div class="proposedPrice" v-if="item.proposedPrice>0">
                                    ¥{{item.proposedPrice}}
                                </div>
                            </div>
                            <div class="goods-credit" v-else-if="item.credit>0">
                                <div class="credit-box">
                                    <div class="credit">{{item.credit}}</div>
                                    <div class="credit-name">{{creditName}}
                                        <div class="qi" v-if="item.skuFlag">起</div>
                                    </div>
                                </div>
                                <div class="proposedPrice" v-if="item.proposedPrice>0">
                                    ¥{{item.proposedPrice}}
                                </div>
                            </div>
                            <div class="goods-free" v-else-if="item.credit<=0&&item.price<=0">
                                <div class="free-box">
                                    免费
                                </div>
                                <div class="proposedPrice" v-if="item.proposedPrice>0">
                                    ¥{{item.proposedPrice}}
                                </div>
                            </div>
                            <div class="goods-ft" v-if="isCloseCart!='T'&&(item.isWechatProfitSharing!='T'||isOpenProfitSharingShopCart=='T')&&isBtn=='T'">
                                <div class="add-shopCar" @click.stop="isShowSku(item)">
                                    <i class="iconfont iconjia"></i>
                                </div>
                            </div>
                        </div>
                        <div class="no-stock" v-if="goodsType=='group'&&item.groupStock!=undefined&&item.groupStock<=0"><img src="https://xcx.ihotel.cn/mall-chain/no-stock.png"></div>
                        <div class="no-stock" v-else-if="item.stock!=undefined&&item.stock<=0"><img src="https://xcx.ihotel.cn/mall-chain/no-stock.png"></img></div>
                    </div>
                </van-cell>
            </template>
        </waterfall>

    </div>
    <div class="goodsList" v-else>
        <van-cell v-for="(item,i) in goodsListData" :key="i" class="goods-box">
            <div class="goods-box-box" v-if="goodsListData.length>0&&(i<number||number==-1)" @click="goGoodsDetail(item,i)">
                <div class="img-box">
                    <div class="img-box-content" :class="{'img-box-square':isSquarePic=='T'}">
                        <div class="label" v-if="item.goodsCity&&item.goodsCity!=''">
                            {{item.goodsCity|keyFilter}}
                        </div>
                        <img class="img" v-if="isSquarePic!='T'" v-lazy="item.logo+'?imageView2/1/w/336/h/224/q80/format/webp&x-oss-process=image/resize,m_fill,w_336,h_224'" />
                        <img class="img" v-else v-lazy="item.logo+'?imageView2/1/w/336/h/336/q80/format/webp&x-oss-process=image/resize,m_fill,w_336,h_336'" />
                        <div class="hotelName" v-if="item.supplierName&&item.supplierName!=''&&showListHotelName!='F'&&hideHotelInfo!='T'">
                            <b>{{item.supplierName}}</b>
                        </div>
                        <div class="hotelName" v-else-if="item.hotelName&&item.hotelName!=''&&showListHotelName!='F'&&hideHotelInfo!='T'">
                            <b>{{item.hotelName}}</b>
                        </div>
                    </div>

                </div>
                <div class="goods-content-common">
                    <div class="goods-name">{{item.name}}</div>
                    <div class="goods-discount" v-if="item.extraInfo&&item.extraInfo.discountList">
                        <div class="goods-discount-item" v-if="item.extraInfo.discountList.length>0" v-for="(discount,j) in item.extraInfo.discountList" :key="j">
                            {{discount.discountTxt}}
                        </div>
                    </div>
                    <div class="goods-price-credit" v-if="item.price>0&&item.credit>0">
                        <div class="price-box">
                            <i class="rmb">¥</i>
                            <div class="price">
                                {{item.price}}
                            </div>
                            <div class="qi" v-if="item.skuFlag">起</div>
                            <div class="proposedPrice" v-if="item.proposedPrice>0">
                                ¥{{item.proposedPrice}}
                            </div>
                        </div>
                        <div class="credit-box">
                            <span v-if="priceOrCredit!='T'">+</span>{{item.credit}}{{creditName}}<span v-if="priceOrCredit=='T'">兑换</span>
                        </div>
                    </div>
                    <div class="goods-price" v-else-if="item.price>0||(item.skuFlag&&item.price<=0&&item.credit<=0)">
                        <div class="price-box">
                            <i class="rmb">¥</i>
                            <div class="price">
                                {{item.price}}
                            </div>
                            <div class="qi" v-if="item.skuFlag">起</div>
                        </div>
                        <div class="proposedPrice" v-if="item.proposedPrice>0">
                            ¥{{item.proposedPrice}}
                        </div>
                    </div>
                    <div class="goods-credit" v-else-if="item.credit>0">
                        <div class="credit-box">
                            <div class="credit">{{item.credit}}</div>
                            <div class="credit-name">{{creditName}}
                                <div class="qi" v-if="item.skuFlag">起</div>
                            </div>
                        </div>
                        <div class="proposedPrice" v-if="item.proposedPrice>0">
                            ¥{{item.proposedPrice}}
                        </div>
                    </div>
                    <div class="goods-free" v-else-if="item.credit<=0&&item.price<=0">
                        <div class="free-box">
                            免费
                        </div>
                        <div class="proposedPrice" v-if="item.proposedPrice>0">
                            ¥{{item.proposedPrice}}
                        </div>
                    </div>
                    <div class="goods-ft" v-if="isCloseCart!='T'&&(item.isWechatProfitSharing!='T'||isOpenProfitSharingShopCart=='T')&&isBtn=='T'">
                        <div class="add-shopCar" @click.stop="isShowSku(item)">
                            <i class="iconfont iconjia"></i>
                        </div>
                    </div>

                </div>
                <div class="no-stock" v-if="goodsType=='group'&&item.groupStock!=undefined&&item.groupStock<=0"><img src="https://xcx.ihotel.cn/mall-chain/no-stock.png"></div>
                <div class="no-stock" v-else-if="item.stock!=undefined&&item.stock<=0"><img src="https://xcx.ihotel.cn/mall-chain/no-stock.png"></img></div>
            </div>
        </van-cell>
    </div>
    <layerSku ref="layerSku" :goodsId="goodsId" :goodsDetail="goodsDetail" :curInfo="curInfo" showBtn=true></layerSku>
</div>
</template>

<script>
import gcTrack from "@/utils/gcTrack";
import {
    jAlert3
} from "@/base/jAlert/jAlert";
import {
    getStorage
} from '@/utils/wxuser';
import layerSku from "@/components/layerSku.vue";
export default {
    data() {
        return {
            wxuser: getStorage("wxuser"),
            user: getStorage("user"),
            col: 2,
            closeWaterfall: getStorage('closeWaterfall') || 'F',
            creditName: getStorage('creditName') || '积分',
            isSquarePic: getStorage('isSquarePic') || 'F',
            showListHotelName: getStorage('showListHotelName') || 'T',
            goodsId: '',
            goodsDetail: {},
            curInfo: {},
        };
    },
    watch: {
        goodsListData: {
            handler(val, oldVal) {
                val.forEach((item, i) => {
                    if (item.fullActivityId && item.extraInfo && item.extraInfo != '') {
                        try {
                            if (item.extraInfo && item.extraInfo != '') {
                                var extraInfo = JSON.parse(item.extraInfo)

                                extraInfo.discountList.forEach(discount => {
                                    if (extraInfo.activityType == 'fullReduction') {
                                        if (extraInfo.discountType == 'quota') {
                                            discount.discountTxt = `满${discount.fullNum}元减${discount.reduceNum}元`
                                        }
                                        if (extraInfo.discountType == 'number') {
                                            discount.discountTxt = `满${discount.fullNum}件减${discount.reduceNum}元`
                                        }
                                        if (extraInfo.discountType == 'circulate') {
                                            discount.discountTxt = `每满${discount.fullNum}元减${discount.reduceNum}元`
                                        }
                                    }
                                    if (extraInfo.activityType == 'fullDiscount') {
                                        discount.discountTxt = `满${discount.fullNum}件${discount.reduceNum}折`
                                    }
                                    if (extraInfo.activityType == 'fullDelivery') {
                                        if (extraInfo.discountType == 'coupons') {
                                            var couponsArr = []
                                            extraInfo.couponsArr.forEach(item => {
                                                couponsArr.push(item.descript)
                                            })
                                            discount.discountTxt = `满${discount.fullNum}元赠送${couponsArr.join(',')}`
                                        }
                                    }

                                })
                                item.extraInfo = extraInfo

                            }

                        } catch (error) {

                        }

                    }

                })
                this.goodsList = val
            },
            immediate: true,
        }
    },

    props: {
        goodsListData: {
            type: Array,
        },
        goods: {
            type: Object,
        },

        goodsType: {
            type: String,
            default () {
                return "";
            },
        },

        totalRows: {
            type: Number,
            default () {
                return 0;
            },
        },

        number: {
            type: Number,
            default () {
                return -1;
            },
        },
        isBtn: {
            type: String,
            default () {
                return "F";
            },
        },
        name: {
            type: String,
            default () {
                return '';
            },
        },
    },
    filters: {
        keyFilter(val) {
            return val.split(',')[0]
        },
        wordLimit(val) {
            return val.substring(0, 4);
        },
    },
    computed: {
        itemWidth() {
            return (167 * (document.documentElement.clientWidth / 375))
        },

    },
    methods: {
        isShowSku(item) {
            if(item.id!=this.goodsId){
                this.curInfo = {
                    currentStock: item.stock,
                    currentPrice: item.price,
                    currentCredit: item.credit,
                    currentPic: item.logo
                };
            }
            this.goodsId = item.id;
            this.goodsDetail = item;
   
            if (!this.user || !this.user.memberId) {
                this.isLogin();
                return false;
            }

            if (item.stock != undefined && item.stock <= 0) {
                jAlert3("商品已售罄");
                return false;
            }
            if (
                this.user &&
                this.goodsDetail.memberLevelLimit &&
                this.goodsDetail.memberLevelLimit != ""
            ) {
                var memberLevelLimit = this.goodsDetail.memberLevelLimit.split(",");
                var isPassLimit = false;
                memberLevelLimit.forEach((item, i) => {
                    if (this.user.cardLevel == item) {
                        isPassLimit = true;
                    }
                });
                if (!isPassLimit) {
                    jAlert3("会员等级不符合");
                    return false;
                }
            }
            this.$refs.layerSku.isShowSku();
        },
        goGroup(goods) {
            this.$router.push({
                path: "/goodsDetail",
                query: {
                    id: goods.id,
                    productType: "group",
                },
            });
        },
        goFlashGoods(item, i) {
            var data = {
                banner_belong_area: '限时抢购',
                banner_type: '商品',
                banner_name: item.goodsName,
                banner_id: item.id,
                banner_rank: i + 1
            }
            gcTrack.track("SC_HomeOoperationClick", data)
            this.$router.push({
                path: "/goodsDetail",
                query: {
                    id: item.id,
                    productType: "flash",
                    flashTimeSlotRelitionId: item.relationId,
                },
            });
        },
        goGoodsDetail(item, i) {
            if (this.goodsType == "group") {
                this.goGroup(item);
            }else if (this.goodsType == "flash") {
                this.goFlashGoods(item, i)
            } else if (this.goodsType == "firstOrder") {
                this.$router.push({
                    path: "/goodsDetail",
                    query: {
                        id: item.id,
                        goodsId: item.goodsId,
                        productType: 'firstOrder'
                    },
                });
            } else {
                var id = item.id || item.goodsId;
                if (this.goodsType == 'hot') {
                    var data = {
                        banner_belong_area: '热门推荐',
                        banner_type: '商品',
                        banner_name: item.name,
                        banner_id: id,
                        banner_rank: i + 1
                    }
                    gcTrack.track("SC_HomeOoperationClick", data)
                }
                if (this.name != '') {
                    var data = {
                        key_word: this.$route.query.name,
                        key_word_type: '用户输入',
                        position_number: i,
                        search_result_number: this.totalRows * 1,
                        commodity_id: item.id,
                        commodity_name: item.name
                    }
                    gcTrack.track("SC_SearchResultClick", data)
                }
                this.$gc.track({
                    behaviorType: 7,
                    goodsId: id,
                    goodsName: item.name
                });
                if(this.goodsType =='employ'){
                     this.$router.push({
                        path: "/goodsDetail",
                        query: {
                            id: id,
                            isEmploy:true
                        },
                    });
                }else{
                     this.$router.push({
                        path: "/goodsDetail",
                        query: {
                            id: id,
                        },
                    });
                }
               
            }
        },
    },
    mounted() {
        console.log(this.datas)
    },
    components: {
        layerSku
    },
    created() {

    },
};
</script>

<style lang="less" scoped>
@import url("~@/styles/base.less");
@import url("~@/styles/mixin.less");

/deep/.vue-waterfall {
    overflow-y: inherit;
}

.goodsList_ui {
    padding-top: 0.4rem;

    .waterfall {
        padding: 0 0.4rem;
        display: flex;

        .goods-box {
            padding-bottom: 0.4rem;
            display: flex;
        }

        .goods-box-box {
            position: relative;
            width: 4.453333rem;
            background: #fff;
            overflow: hidden;
            display: inline-block;
            border-radius: 0.106667rem;
            height: 100%;
            box-sizing: border-box;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.06);

            .img-box {
                position: relative;

                .img-box-content {
                    width: 4.453333rem;
                    overflow: hidden;

                    position: relative;

                    .label {
                        position: absolute;
                        z-index: 2;
                        color: #fff;
                        text-align: center;
                        border-radius: 3px 3px 11px 0px;
                        padding: 0.16rem 0.266667rem 0.16rem 0.16rem;
                        background: @label-color;
                    }

                    .hotelName {
                        position: absolute;
                        bottom: 0;
                        left: 50%;
                        width: 3.83904rem;
                        margin-left: -1.91952rem;
                        height: 0.47988rem;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;

                        b {
                            position: absolute;
                            width: 100%;
                            height: 0.47988rem;
                            z-index: 2;
                            font-size: 10px;
                            color: #fff;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 1;
                            white-space: normal;
                            line-height: 0.47988rem;
                            text-align: center;
                            padding: 0 0.266667rem;
                        }

                        &:after {
                            content: "";
                            position: absolute;
                            bottom: 0;
                            z-index: 1;
                            left: 50%;
                            margin-left: -1.5996rem;
                            width: 3.1992rem;
                            background: @color-theme;
                            opacity: 0.6;
                            height: 0.47988rem;
                            box-sizing: border-box;
                            border-radius: 0.21328rem 0.21328rem 0 0;
                            transform: perspective(0.2666rem) scale(1.1, 1.3) rotateX(5deg);
                        }
                    }

                    .img {
                        width: 100%;
                        height: 100%;

                        // border-radius: 0.32rem;
                    }
                }

                .bg {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    left: 0;
                    top: 0;
                }
            }

            .goods-content-common {
                padding: 0.213333rem 0.266667rem 0.266667rem;

                .goods-discount {
                    height: 19px;
                    overflow: hidden;

                    .goods-discount-item {
                        border-radius: 2px;
                        color: @color-price;
                        font-size: 10px;
                        margin-top: 5px;
                        border: 1px solid @color-price;
                        display: inline-block;
                        padding: 0 2px;
                        line-height: 14px;
                        height: 14px;
                        margin-right: 0.133333rem;
                        white-space: nowrap;
                    }
                }

                .goods-name {
                    font-size: 14px;
                    color: #333333;
                    font-family: PingFangSC-Regular;
                    text-align: left;
                    line-height: 0.533333rem;
                    max-height: 1.066667rem;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    white-space: normal;
                    overflow: hidden;
                    color: #333333;
                }

                .goods-free {
                    line-height: 1.4;
                    margin-top: 0.133333rem;

                    .free-box {
                        font-family: PingFangTC-Regular;
                        font-size: 19px;
                        color: @color-price;
                    }

                    .proposedPrice {
                        margin-top: 0.133333rem;
                        font-size: 12px;
                        color: #888888;
                        font-family: PingFangSC-Regular;
                        text-decoration: line-through;
                    }
                }

                .qi {
                    display: inline;
                    font-size: @price-font-size;
                    color: @color-price;
                }

                .goods-price {
                    margin-top: 0.133333rem;
                    line-height: 1.4;

                    .price-box {
                        .rmb {
                            font-family: @price-font-family;
                            font-size: 16px;
                            color: @color-price;
                            display: inline;
                        }

                        .price {
                            display: inline;
                            font-family: @price-font-family;
                            font-size: @price-font-size-big;
                            color: @color-price;
                        }
                    }

                    .proposedPrice {
                        margin-top: 0.133333rem;
                        font-size: 12px;
                        color: #888888;
                        font-family: PingFangSC-Regular;
                        text-decoration: line-through;
                    }
                }

                .goods-credit {
                    margin-top: 0.133333rem;
                    line-height: 1.4;

                    .credit-box {
                        .credit {
                            display: inline;
                            font-family: @price-font-family;
                            font-size: @price-font-size-big;
                            color: @color-price;
                        }

                        .credit-name {
                            display: inline;
                            font-size: 12px;
                            color: @color-price;
                        }
                    }

                    .proposedPrice {
                        margin-top: 0.133333rem;
                        font-size: 12px;
                        color: #888888;
                        font-family: PingFangSC-Regular;
                        text-decoration: line-through;
                    }
                }

                .goods-price-credit {
                    margin-top: 0.133333rem;
                    line-height: 1.4;

                    .price-box {
                        .rmb {
                            font-family: @price-font-family;
                            font-size: 16px;
                            color: @color-price;
                            display: inline;
                        }

                        .price {
                            display: inline;
                            font-family: @price-font-family;
                            font-size: @price-font-size-big;
                            color: @color-price;
                        }

                        .proposedPrice {
                            display: inline;
                            font-size: 12px;
                            color: #888888;
                            font-family: PingFangSC-Regular;
                            text-decoration: line-through;
                        }
                    }

                    .credit-box {
                        margin-top: 0.133333rem;
                        font-size: 12px;
                        color: @color-credit;
                    }
                }

                .desc {
                    font-size: 12px;
                    color: #333333;
                    height: 0.96rem;
                    width: 100%;
                    text-align: left;
                    white-space: normal;
                    line-height: 0.48rem;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;

                    &.center {
                        text-align: center;
                    }
                }

                .btn {
                    display: flex;
                    justify-content: center;
                    margin-top: 0.133333rem;

                    img {
                        width: 2.533333rem;
                        height: 0.48rem;
                    }
                }
            }

            .goods-content {
                padding: 0 0.213333rem;
                // height: 3.173333rem;
                text-align: center;

                .goods-name {
                    font-weight: bold;
                    font-size: 15px;
                    text-align: left;
                    height: 0.8rem;
                    line-height: 0.8rem;

                    overflow: hidden;
                    color: #333333;
                }

                .desc {
                    font-size: 12px;
                    color: #333333;
                    height: 0.96rem;
                    width: 100%;
                    text-align: left;
                    white-space: normal;
                    line-height: 0.48rem;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;

                    &.center {
                        text-align: center;
                    }
                }

                .goods-price {
                    display: flex;
                    justify-content: center;
                }

                .btn {
                    display: flex;
                    justify-content: center;
                    margin-top: 0.133333rem;

                    img {
                        width: 2.533333rem;
                        height: 0.48rem;
                    }
                }
            }

            .no-stock {
                border-radius: 0.106667rem;
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: rgba(255, 255, 255, 0.8);
                z-index: 8;

                img {
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    width: 2.213333rem;
                    height: 1.253333rem;
                    transform: translate(-50%, -50%);
                }
            }
        }
    }

    .goods-ft {
        position: absolute;
        bottom: 0.266667rem;
        right: 0.266667rem;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .add-shopCar {
            text-align: center;
            font-size: 24px;
            border-radius: 50%;
            color: #fff;
            width: 0.96rem;

            display: flex;
            align-items: center;
            justify-content: flex-end;

            i {
                display: flex;
                align-items: center;
                justify-content: center;
                background: @color-theme;
                height: 0.56rem;
                width: 0.56rem;
                color: #fff;
                border-radius: 50%;
                box-shadow: 0 2px 4px 0 rgba(47, 79, 79, 0.08);
                font-size: 10px;
            }

            image {
                width: 100%;
                height: 100%;
            }
        }
    }

    .goodsList {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding: 0 0.4rem;

        .goods-box {
            padding-bottom: 0.4rem;
        }

        .goods-box-box {
            position: relative;
            width: 4.453333rem;
            background: #fff;
            overflow: hidden;
            display: inline-block;
            border-radius: 0.106667rem;
            height: 100%;
            box-sizing: border-box;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.06);

            .img-box {
                position: relative;

                .img-box-content {
                    width: 4.453333rem;
                    overflow: hidden;
                    height: 2.969rem;
                    position: relative;

                    &.img-box-square {
                        height: 4.453333rem;
                    }

                    .label {
                        position: absolute;
                        z-index: 2;
                        color: #fff;
                        text-align: center;
                        border-radius: 3px 3px 11px 0px;
                        padding: 0.16rem 0.266667rem 0.16rem 0.16rem;
                        background: @label-color;
                    }

                    .img {
                        width: 100%;
                        height: 100%;

                        // border-radius: 0.32rem;
                    }
                }

                .bg {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    left: 0;
                    top: 0;
                }

                .hotelName {
                    position: absolute;
                    bottom: 0;
                    left: 50%;
                    width: 3.83904rem;
                    margin-left: -1.91952rem;
                    height: 0.47988rem;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;

                    b {
                        position: absolute;
                        width: 100%;
                        height: 0.47988rem;
                        z-index: 2;
                        font-size: 10px;
                        color: #fff;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 1;
                        white-space: normal;
                        line-height: 0.47988rem;
                        text-align: center;
                        padding: 0 0.266667rem;
                    }

                    &:after {
                        content: "";
                        position: absolute;
                        bottom: 0;
                        z-index: 1;
                        left: 50%;
                        margin-left: -1.5996rem;
                        width: 3.1992rem;
                        background: @color-theme;
                        opacity: 0.6;
                        height: 0.47988rem;
                        box-sizing: border-box;
                        border-radius: 0.21328rem 0.21328rem 0 0;
                        transform: perspective(0.2666rem) scale(1.1, 1.3) rotateX(5deg);
                    }
                }
            }

            .goods-content-common {
                padding: 0.213333rem 0.266667rem 0.266667rem;

                .goods-name {
                    font-size: 14px;
                    color: #333333;
                    font-family: PingFangSC-Regular;
                    text-align: left;
                    line-height: 0.533333rem;
                    height: 1.066667rem;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    white-space: normal;
                    overflow: hidden;
                    color: #333333;
                }

                .goods-discount {
                    height: 19px;
                    overflow: hidden;

                    .goods-discount-item {
                        border-radius: 2px;
                        color: @color-price;
                        font-size: 10px;
                        margin-top: 5px;
                        border: 1px solid @color-price;
                        display: inline-block;
                        padding: 0 2px;
                        line-height: 14px;
                        height: 14px;
                        margin-right: 0.133333rem;
                        white-space: nowrap;
                    }
                }

                .qi {
                    display: inline;
                    font-size: @price-font-size;
                    color: @color-price;
                }

                .goods-free {
                    line-height: 1.4;
                    margin-top: 0.133333rem;

                    .free-box {
                        font-family: PingFangTC-Regular;
                        font-size: 19px;
                        color: @color-price;
                    }

                    .proposedPrice {
                        margin-top: 0.133333rem;
                        font-size: 12px;
                        color: #888888;
                        font-family: PingFangSC-Regular;
                        text-decoration: line-through;
                    }
                }

                .goods-price {
                    line-height: 1.4;
                    margin-top: 0.133333rem;

                    .price-box {
                        .rmb {
                            font-family: @price-font-family;
                            font-size: 16px;
                            color: @color-price;
                            display: inline;
                        }

                        .price {
                            display: inline;
                            font-family: @price-font-family;
                            font-size: @price-font-size-big;
                            color: @color-price;
                        }
                    }

                    .proposedPrice {
                        margin-top: 0.133333rem;
                        font-size: 12px;
                        color: #888888;
                        font-family: PingFangSC-Regular;
                        text-decoration: line-through;
                    }
                }

                .goods-credit {
                    line-height: 1.4;
                    margin-top: 0.133333rem;

                    .credit-box {
                        .credit {
                            display: inline;
                            font-family: @price-font-family;
                            font-size: @price-font-size-big;
                            color: @color-price;
                        }

                        .credit-name {
                            display: inline;
                            font-size: 12px;
                            color: @color-price;
                        }
                    }

                    .proposedPrice {
                        margin-top: 0.133333rem;
                        font-size: 12px;
                        color: #888888;
                        font-family: PingFangSC-Regular;
                        text-decoration: line-through;
                    }
                }

                .goods-price-credit {
                    line-height: 1.4;
                    margin-top: 0.133333rem;

                    .price-box {
                        .rmb {
                            font-family: @price-font-family;
                            font-size: 16px;
                            color: @color-price;
                            display: inline;
                        }

                        .price {
                            display: inline;
                            font-family: @price-font-family;
                            font-size: @price-font-size-big;
                            color: @color-price;
                        }

                        .proposedPrice {
                            display: inline;
                            font-size: 12px;
                            color: #888888;
                            font-family: PingFangSC-Regular;
                            text-decoration: line-through;
                        }
                    }

                    .credit-box {
                        margin-top: 0.133333rem;
                        font-size: 12px;
                        color: @color-credit;
                    }
                }

                .desc {
                    font-size: 12px;
                    color: #333333;
                    height: 0.96rem;
                    width: 100%;
                    text-align: left;
                    white-space: normal;
                    line-height: 0.48rem;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;

                    &.center {
                        text-align: center;
                    }
                }

                .btn {
                    display: flex;
                    justify-content: center;
                    margin-top: 0.133333rem;

                    img {
                        width: 2.533333rem;
                        height: 0.48rem;
                    }
                }
            }

            .goods-content {
                padding: 0 0.213333rem;
                // height: 3.173333rem;
                text-align: center;

                .goods-name {
                    font-weight: bold;
                    font-size: 15px;
                    text-align: left;
                    height: 0.8rem;
                    line-height: 0.8rem;

                    overflow: hidden;
                    color: #333333;
                }

                .desc {
                    font-size: 12px;
                    color: #333333;
                    height: 0.96rem;
                    width: 100%;
                    text-align: left;
                    white-space: normal;
                    line-height: 0.48rem;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;

                    &.center {
                        text-align: center;
                    }
                }

                .goods-price {
                    display: flex;
                    justify-content: center;
                }

                .btn {
                    display: flex;
                    justify-content: center;
                    margin-top: 0.133333rem;

                    img {
                        width: 2.533333rem;
                        height: 0.48rem;
                    }
                }
            }

            .no-stock {
                border-radius: 0.106667rem;
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: rgba(255, 255, 255, 0.8);
                z-index: 8;

                img {
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    width: 2.213333rem;
                    height: 1.253333rem;
                    transform: translate(-50%, -50%);
                }
            }
        }
    }

    .goods-ft {
        position: absolute;
        bottom: 0;
        right: 0.266667rem;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .add-shopCar {
            text-align: center;
            font-size: 24px;
            border-radius: 50%;
            color: #fff;
            width: 0.96rem;
            line-height: 0.586667rem;
            height: 0.96rem;
            display: flex;
            align-items: center;
            justify-content: flex-end;

            i {
                display: flex;
                align-items: center;
                justify-content: center;
                background: @color-theme;
                height: 0.56rem;
                width: 0.56rem;
                color: #fff;
                border-radius: 50%;
                box-shadow: 0 2px 4px 0 rgba(47, 79, 79, 0.08);
                font-size: 10px;
            }

            image {
                width: 100%;
                height: 100%;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/goodsList.vue